import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import VendorCollectionsTable from './VendorCollectionsTable';
import VendorCollectionEditView from './VendorCollectionEditView';

const VendorCollectionsView = () => (
  <Routes>
    <Route element={<VendorCollectionEditView />} path="/new" />
    <Route
      element={<VendorCollectionEditView />}
      path="/:pkEcomVendorCollection"
    />
    <Route
      element={<VendorCollectionEditView duplicate />}
      path="/:pkEcomVendorCollection/duplicate"
    />
    <Route element={<VendorCollectionsTable />} path="/" />
    <Route element={<Navigate replace to="/vendor/collections" />} path="*" />
  </Routes>
);

export default VendorCollectionsView;
